import React, { useEffect, useState } from 'react';
import { get, del } from '../../services/api';   // ✅ utiliser ton api.js
import ProductList from '../../components/admin/ProductList';

function ProduitsValides() {
  const [produits, setProduits] = useState([]);

  useEffect(() => {
    const fetchProduits = async () => {
      try {
        const res = await get('/produits/valides-avec-vendeur'); // ✅ corrigé
        setProduits(res.data);
      } catch (error) {
        console.error('Erreur chargement produits validés :', error);
      }
    };

    fetchProduits();

    const handleProduitValide = () => {
      fetchProduits();
    };

    window.addEventListener('produitValide', handleProduitValide);
    return () => {
      window.removeEventListener('produitValide', handleProduitValide);
    };
  }, []);

  const handleEdit = (produit) => {
    console.log('Modifier produit :', produit);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Supprimer ce produit ?')) {
      try {
        await del(`/produits/${id}?vendeur_id=1`); // ✅ corrigé
        setProduits((prev) => prev.filter((p) => p.id !== id));
      } catch (error) {
        alert('Erreur suppression produit');
      }
    }
  };

  return (
    <div>
      <ProductList
        produits={produits}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    </div>
  );
}

export default ProduitsValides;
